import {
  Component,
  computed,
  ElementRef,
  inject,
  input,
  OnDestroy,
  OnInit,
  viewChild,
} from '@angular/core'
import { Message } from '@app/model/message.model'
import { BaseModal } from '@app/pages/base.modal'
import { confettiService } from '@app/srv/confetti.service'
import { runOutsideAngular } from '@app/srv/di.service'
import { MarkdownService } from '@app/srv/markdown.service'
import {
  IonButton,
  IonButtons,
  IonFooter,
  IonHeader,
  IonIcon,
  IonLabel,
  IonToolbar,
} from '@ionic/angular/standalone'
import { MediaType, MessageStyle } from '@naturalcycles/shared'
import { AnimationComponent } from '@src/app/cmp/animation/animation.component.js'
import { DEFAULT_CONFIG } from '@src/app/cnst/animations.cnst.js'
import { TrPipe } from '@src/app/pipes/tr.pipe.js'
import { MarkdownPipe } from '../../pipes/markdown.pipe.js'
import { SafePipe } from '../../pipes/safe.pipe.js'
import { StripTagsPipe } from '../../pipes/strip-tags.pipe.js'

@Component({
  selector: 'confetti-message-modal',
  templateUrl: './confetti-message.modal.html',
  styleUrls: ['./confetti-message.modal.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonFooter,
    IonLabel,
    MarkdownPipe,
    SafePipe,
    StripTagsPipe,
    AnimationComponent,
    TrPipe,
  ],
})
export class ConfettiMessageModal extends BaseModal implements OnInit, OnDestroy {
  className = 'ConfettiMessageModal'

  protected markdownService = inject(MarkdownService)

  protected message = input.required<Message>()

  protected animationConfig = computed(() => {
    const animation = this.message().media?.find(m => m.type === MediaType.ANIMATION)
    if (!animation) return
    return { ...DEFAULT_CONFIG, src: animation.url }
  })

  private el = viewChild<ElementRef>('confetti')
  protected readonly MediaType = MediaType
  protected readonly MessageStyle = MessageStyle

  public ngOnInit(): void {
    void import('@app/srv/confetti.service').then(({ confettiService }) => {
      runOutsideAngular(() => void confettiService.addConfetti(this.el()?.nativeElement))
    })
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy()
    confettiService.reset()
  }
}
